import { InformationDialogData } from '../../../../core/interfaces/information-dialog';

export enum InformationDialogs {
	GATEWAY_REDIRECT,
	TWILIO_ACTIVE_STREAMS
}

export namespace InformationDialogsGetter {
	export function getDialogData(mode: InformationDialogs): InformationDialogData {
		switch (mode) {
			case InformationDialogs.GATEWAY_REDIRECT: {
				return {
					titleKey: 'gatewayRedirectInformation.title',
					videoKey: '/assets/gif/gateway-redirect.gif',
					messageKey: 'gatewayRedirectInformation.message',
					hideActionMessageKey: 'gatewayRedirectInformation.hide_action_message',
					actionButtonKey: 'buttons.ok',
					cancelButtonKey: 'buttons.cancel'
				};
			}
			case InformationDialogs.TWILIO_ACTIVE_STREAMS: {
				return {
					titleKey: 'integrations.twilio.cannot-remove-twilio',
					actionButtonKey: 'buttons.ok',
				};
			}
		}
	}
}
